"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80],{

/***/ 722662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UI": function() { return /* reexport */ SearchForm; }
});

// UNUSED EXPORTS: isCurrentDate, mapFormValueToOptions, mergeInitialFormWithDefaultParams

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(370917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(759499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(750029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(487794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 5 modules
var useQuery = __webpack_require__(790001);
// EXTERNAL MODULE: ./src/components/ApiClientProvider/index.ts + 6 modules
var ApiClientProvider = __webpack_require__(619812);
// EXTERNAL MODULE: ./src/shared-components/index.ts + 30 modules
var shared_components = __webpack_require__(175466);
// EXTERNAL MODULE: ./src/shared-components/PUIAutocomplete/index.ts + 1 modules
var PUIAutocomplete = __webpack_require__(824911);
// EXTERNAL MODULE: ./src/shared-components/PUIButton/PUIButton.tsx
var PUIButton = __webpack_require__(663450);
// EXTERNAL MODULE: ./src/shared-components/PUIDatePicker/PUIDatePicker.tsx + 181 modules
var PUIDatePicker = __webpack_require__(410978);
// EXTERNAL MODULE: ./src/shared-components/PUIGrid/index.ts + 2 modules
var PUIGrid = __webpack_require__(530147);
// EXTERNAL MODULE: ./src/components/SearchForm/search.ts + 4 modules
var search = __webpack_require__(780503);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var emotion_element_6a883da9_browser_esm = __webpack_require__(152443);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(287536);
// EXTERNAL MODULE: ./src/components/useFetchErrorMessage/index.ts + 1 modules
var useFetchErrorMessage = __webpack_require__(649371);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(496486);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
;// CONCATENATED MODULE: ./src/components/SearchForm/SearchForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var STALE_TIME = Infinity;

var useGeoSuggestions = function useGeoSuggestions(inputText) {
  var _useApiClient = (0,ApiClientProvider/* useApiClient */.mb)(),
      gatewayClient = _useApiClient.gatewayClient;

  var _useQuery = (0,useQuery/* useQuery */.a)(['geo-suggestions', inputText], /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var queryKey, prefixParam, response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryKey = _ref.queryKey;
              prefixParam = queryKey[1];

              if (!(gatewayClient !== null && prefixParam.length > 0)) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return gatewayClient.operations.geo_suggestions_v1_geo_suggestions_get([{
                name: 'prefix',
                value: prefixParam,
                "in": 'query'
              }]);

            case 5:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 7:
              return _context.abrupt("return", []);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    staleTime: STALE_TIME
  }),
      options = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    options: options !== null && options !== void 0 ? options : [],
    isLoading: isLoading
  };
};

var isCurrentDate = function isCurrentDate(date) {
  var dateStr;

  try {
    dateStr = date.toISOString().split('T')[0];
  } catch (error) {
    if (error instanceof RangeError) {
      return false;
    }
  }

  var currentDateStr = new Date().toISOString().split('T')[0];
  return dateStr === currentDateStr;
};
var mapFormValueToOptions = function mapFormValueToOptions(allOptions, formValue) {
  var _allOptions$filter;

  if (!formValue) return [];
  return (_allOptions$filter = allOptions === null || allOptions === void 0 ? void 0 : allOptions.filter(function (val) {
    return formValue.includes(val.value);
  })) !== null && _allOptions$filter !== void 0 ? _allOptions$filter : [];
};
function mergeInitialFormWithDefaultParams(initialForm, defaultParameters) {
  if (typeof initialForm === 'undefined') return defaultParameters;
  return (0,lodash.mergeWith)(initialForm, defaultParameters, // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  function (objVal, srcVal) {
    return objVal == null ? srcVal : objVal;
  });
}
var SearchForm = function SearchForm(_ref3) {
  var _watch;

  var onSearch = _ref3.onSearch,
      initialForm = _ref3.initialForm;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useApiClient2 = (0,ApiClientProvider/* useApiClient */.mb)(),
      gatewayClient = _useApiClient2.gatewayClient;

  var defaultSearchParams = mergeInitialFormWithDefaultParams(initialForm, (0,search/* getDefaultSearchParams */.GP)());

  var _useForm = (0,index_esm/* useForm */.cI)({
    // TODO: should we remove watching on "equipmentType" field or change the validation mode to onSubmit or onBlur?
    mode: 'onChange',
    defaultValues: defaultSearchParams
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      getValues = _useForm.getValues,
      watch = _useForm.watch,
      formState = _useForm.formState,
      setValue = _useForm.setValue;

  console.log('form values', getValues());

  var resetEquipmentSubtypes = function resetEquipmentSubtypes() {
    setValue('equipmentSubtype', []);
    setValue('equipmentAccessorials', []);
    setValue('equipmentExtras', []);
  };

  var onSubmit = function onSubmit(data) {
    return onSearch && onSearch(data);
  };

  var onSubmitHandler = handleSubmit(onSubmit);
  var handleFetchError = (0,useFetchErrorMessage/* useFetchErrorMessage */.p)();
  var equipmentType = (_watch = watch('equipmentType')) !== null && _watch !== void 0 ? _watch : '';

  var _useQuery2 = (0,useQuery/* useQuery */.a)(['equipment-info'], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var _gatewayClient$operat;

    var response;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return gatewayClient === null || gatewayClient === void 0 ? void 0 : (_gatewayClient$operat = gatewayClient.operations) === null || _gatewayClient$operat === void 0 ? void 0 : _gatewayClient$operat.get_equipment_v1_equipment_get();

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), {
    staleTime: STALE_TIME,
    onError: function onError(error) {
      handleFetchError(error, 'Equipment Information');
    }
  }),
      equipmentInfo = _useQuery2.data,
      isEquipmentLoading = _useQuery2.isLoading;

  var _useQuery3 = (0,useQuery/* useQuery */.a)(['load-extras'], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var _gatewayClient$operat2;

    var response;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return gatewayClient === null || gatewayClient === void 0 ? void 0 : (_gatewayClient$operat2 = gatewayClient.operations) === null || _gatewayClient$operat2 === void 0 ? void 0 : _gatewayClient$operat2.get_load_extras_v1_load_extras_get();

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), {
    staleTime: STALE_TIME,
    onError: function onError(error) {
      handleFetchError(error, 'Load Extras');
    }
  }),
      loadExtras = _useQuery3.data;

  var equipmentTypeOptions = equipmentInfo && (0,search/* convertArrayToSelectOptions */.nA)(Object.keys(equipmentInfo));
  var equipmentSubtypeOptions = (0,search/* getEquipmentSubOptions */.Jc)(equipmentInfo, equipmentType, 'SUBTYPES');
  var equipmentAccessorialOptions = (0,search/* getEquipmentSubOptions */.Jc)(equipmentInfo, equipmentType, 'ACCESSORIALS');
  var loadExtrasOptions = loadExtras && (0,search/* convertObjectToSelectOptions */.SV)(_objectSpread({}, loadExtras));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(shared_components.PUIForm, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUICardSimple, {
      size: "large",
      className: "my3",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PUIGrid/* PUIGrid */.n, {
        spacing: 8,
        columns: 12,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "pickup",
            control: control,
            rules: {
              required: true
            },
            render: function render(_ref6) {
              var _ref6$field = _ref6.field,
                  onChange = _ref6$field.onChange,
                  value = _ref6$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Pickup *",
                useOptionsHook: useGeoSuggestions,
                multiple: false,
                onChange: onChange,
                value: value
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "delivery",
            control: control,
            rules: {
              required: true
            },
            render: function render(_ref7) {
              var _ref7$field = _ref7.field,
                  onChange = _ref7$field.onChange,
                  value = _ref7$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Delivery *",
                useOptionsHook: useGeoSuggestions,
                multiple: false,
                onChange: onChange,
                value: value
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "date",
            control: control,
            rules: {
              required: true
            },
            render: function render(_ref8) {
              var _ref8$field = _ref8.field,
                  onChange = _ref8$field.onChange,
                  value = _ref8$field.value;
              console.log('datepicker value', value);
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIDatePicker/* default */.Z, {
                label: "Date *",
                onChange: onChange,
                value: value,
                fullWidth: true,
                disablePast: true,
                addonEnd: value && isCurrentDate(value) && 'Today'
              });
            }
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUICardSimple, {
      size: "large",
      className: "my3",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PUIGrid/* PUIGrid */.n, {
        spacing: 8,
        columns: 12,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "equipmentType",
            control: control,
            rules: {
              required: true
            },
            render: function render(_ref9) {
              var _ref9$field = _ref9.field,
                  _onChange = _ref9$field.onChange,
                  value = _ref9$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Equipment *",
                multiple: false,
                useOptionsHook: function useOptionsHook() {
                  return {
                    options: equipmentTypeOptions !== null && equipmentTypeOptions !== void 0 ? equipmentTypeOptions : [],
                    isLoading: isEquipmentLoading
                  };
                },
                onChange: function onChange(option) {
                  _onChange(option === null || option === void 0 ? void 0 : option.value);

                  if ((option === null || option === void 0 ? void 0 : option.value) !== value) {
                    resetEquipmentSubtypes();
                  }
                },
                value: value ? {
                  value: value
                } : null
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "equipmentSubtype",
            control: control,
            rules: {
              required: false
            },
            render: function render(_ref10) {
              var _ref10$field = _ref10.field,
                  _onChange2 = _ref10$field.onChange,
                  value = _ref10$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Subtype",
                multiple: true,
                limitTags: 4,
                disabled: (equipmentSubtypeOptions === null || equipmentSubtypeOptions === void 0 ? void 0 : equipmentSubtypeOptions.length) === 0,
                useOptionsHook: function useOptionsHook() {
                  return {
                    options: equipmentSubtypeOptions !== null && equipmentSubtypeOptions !== void 0 ? equipmentSubtypeOptions : [],
                    isLoading: isEquipmentLoading
                  };
                },
                onChange: function onChange(options) {
                  return _onChange2(options === null || options === void 0 ? void 0 : options.map(function (o) {
                    return o.value;
                  }));
                },
                value: mapFormValueToOptions(equipmentSubtypeOptions, value)
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "equipmentAccessorials",
            control: control,
            rules: {
              required: false
            },
            render: function render(_ref11) {
              var _ref11$field = _ref11.field,
                  _onChange3 = _ref11$field.onChange,
                  value = _ref11$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Accessorials",
                multiple: true,
                limitTags: 4,
                disabled: (equipmentAccessorialOptions === null || equipmentAccessorialOptions === void 0 ? void 0 : equipmentAccessorialOptions.length) === 0,
                useOptionsHook: function useOptionsHook() {
                  return {
                    options: equipmentAccessorialOptions !== null && equipmentAccessorialOptions !== void 0 ? equipmentAccessorialOptions : [],
                    isLoading: isEquipmentLoading
                  };
                },
                onChange: function onChange(options) {
                  return _onChange3(options === null || options === void 0 ? void 0 : options.map(function (o) {
                    return o.value;
                  }));
                },
                value: mapFormValueToOptions(equipmentAccessorialOptions, value)
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "equipmentExtras",
            control: control,
            rules: {
              required: false
            },
            render: function render(_ref12) {
              var _ref12$field = _ref12.field,
                  _onChange4 = _ref12$field.onChange,
                  value = _ref12$field.value;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIAutocomplete/* PUIAutocomplete */.gw, {
                label: "Extras",
                multiple: true,
                limitTags: 4,
                disabled: (loadExtrasOptions === null || loadExtrasOptions === void 0 ? void 0 : loadExtrasOptions.length) === 0,
                useOptionsHook: function useOptionsHook() {
                  return {
                    options: loadExtrasOptions !== null && loadExtrasOptions !== void 0 ? loadExtrasOptions : [],
                    isLoading: isEquipmentLoading
                  };
                },
                onChange: function onChange(options) {
                  return _onChange4(options === null || options === void 0 ? void 0 : options.map(function (o) {
                    return o.value;
                  }));
                },
                value: mapFormValueToOptions(loadExtrasOptions, value)
              });
            }
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        marginTop: theme.spacing(4)
      },  true ? "" : 0,  true ? "" : 0),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGrid */.n, {
        justifyContent: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIGrid/* PUIGridItem */.r, {
          md: 3,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIButton/* PUIButton */.a, {
            type: "submit",
            fullWidth: true,
            variant: "contained",
            disabled: !formState.isValid,
            onClick: function onClick(e) {
              return void onSubmitHandler(e);
            },
            children: "SEARCH"
          })
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/SearchForm/index.ts


/***/ }),

/***/ 649371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ useFetchErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(409669);
// EXTERNAL MODULE: ./src/components/ApiClientProvider/index.ts + 6 modules
var ApiClientProvider = __webpack_require__(619812);
// EXTERNAL MODULE: ./src/shared-components/index.ts + 30 modules
var shared_components = __webpack_require__(175466);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
;// CONCATENATED MODULE: ./src/components/useFetchErrorMessage/useFetchErrorMessage.tsx







var FetchErrorMessage = function FetchErrorMessage(_ref) {
  var error = _ref.error,
      errorType = _ref.errorType;

  var errorMessage = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: String(error)
  });

  if (error instanceof axios.AxiosError) {
    var _error$response, _error$response$data;

    if ((_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.detail && error.response.data.detail.message) {
      errorMessage = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: error.response.data.detail.message
      });
    } else {
      errorMessage = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: "Could not load data for \"".concat(errorType, "\" due to the error: ").concat(error.message, ".")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: "Please refresh the page and try again."
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: "Reach out to our Customer Service if the error persists"
        })]
      });
    }
  }

  return errorMessage;
}; // TODO: call handleFetchError globally for all queries from the FetchClientProvider.tsx (see Jira issue PEP-691)


var useFetchErrorMessage = function useFetchErrorMessage() {
  var _useToasters = (0,shared_components.useToasters)(),
      enqueueToaster = _useToasters.enqueueToaster;

  var _useApiClient = (0,ApiClientProvider/* useApiClient */.mb)(),
      session = _useApiClient.session;

  return function handleFetchError(error, erroredModuleName) {
    if ((0,shared_components.isAxiosAuthorizationError)(error)) {
      // TODO: this type of error should not be logged as a real error
      session.logout(true);
      return;
    }

    enqueueToaster('error', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FetchErrorMessage, {
      error: error,
      errorType: erroredModuleName
    }));
    console.error("Could not load data for \"".concat(erroredModuleName, "\" due to the error: ").concat(error.message), error);
  };
};
;// CONCATENATED MODULE: ./src/components/useFetchErrorMessage/index.ts


/***/ })

}]);